import { FinanceOperationsAddFormRequestType } from "@/form/finance/finance_operations/FinanceOperationsAddForm.types";
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { ResponseDataType } from '@/form/form.types';
import {
    IFinanceOperations,
    IFinanceOperationsListItem,
} from '@/entity/finance/finance_operations/financeOperations.types';
import { FinanceOperationsGeneralRequestType } from '@/form/finance/finance_operations/FinanceOperationsGeneral.types';
import { prepareFormData } from '@/store/utils/formDataHelper';
import { checkUserRole, getUserData } from '@/router/Lib/helper';
import { getStudioId } from "@/UI/lib/state";

@Module({
    namespaced: true,
    name: 'financeOperations',
    store,
    dynamic: true,
})
class FinanceOperationsModule extends VuexModule implements IStoreReady {
    items: IFinanceOperations | null = null;
    item: IFinanceOperationsListItem | null = null;
    itemsLoaded = false;
    ready = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ items: IFinanceOperations; itemsLoaded: boolean }> {
        let itemsLoaded = false;
        const items = await store.$repository.financeOperations.fetchAll(prepareFormData(data));
        if (items) {
            itemsLoaded = true;
        }
        return { items, itemsLoaded };
    }
    @Action({ rawError: true })
    async import(data: File): Promise<ResponseDataType> {
        const formData = new FormData();
        /*if (checkUserRole() == 'admin' && store.state.salon_id) {
            formData.append('salon_id', store.state.salon_id.toString());
        } else if(checkUserRole() == 'owner')
        {
            const userData = getUserData();
            formData.append('salon_id', userData.studios.toString());
        }*/
        formData.append('salon_id', getStudioId(this));

        formData.append('import_file', data);
        return await store.$repository.financeOperations.import(formData);
    }
    @Action({ rawError: true })
    async export(): Promise<ResponseDataType> {
        const formData = new FormData();
        if (checkUserRole() == 'owner') {
            const userData = getUserData();
            formData.append('salon_id', userData.studios.toString());
        }
        else if(store.state.salon_id)
        {
            formData.append('salon_id', store.state.salon_id.toString());
        }
        return await store.$repository.financeOperations.export(formData);
    }
    @Action({ rawError: true })
    async create(data: FinanceOperationsAddFormRequestType): Promise<ResponseDataType> {
        return await store.$repository.financeOperations.create(data);
    }
    @Action({ rawError: true })
    async update(data: FinanceOperationsGeneralRequestType): Promise<ResponseDataType> {
        return await store.$repository.financeOperations.update(data);
    }

    @Mutation
    setReady(st: boolean) {
        this.ready = st;
    }
}

export const FinanceOperationsStore = getModule(FinanceOperationsModule);
